import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { AuthLayout, PasswordInput, FieldLabel, FormError } from "@/components/auth/AuthLayout";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try { await login(email, password); nav("/"); } catch (err) { setError(formatApiError(err)); } finally { setBusy(false); }
  };

  return (
    <AuthLayout title="Welcome back" subtitle="The stars remember your story. Step inside.">
      <form onSubmit={submit} className="space-y-5" data-testid="login-form">
        <div><FieldLabel htmlFor="email">Email</FieldLabel>
          <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="h-11 bg-[#0a0816] border-[#2d2650] mystic-input" data-testid="login-email-input" /></div>
        <div>
          <div className="flex justify-between items-center"><FieldLabel htmlFor="password">Password</FieldLabel>
            <Link to="/forgot-password" className="text-xs text-[#00E5FF] hover:underline mb-2" data-testid="forgot-password-link">Forgot password?</Link></div>
          <PasswordInput id="password" required value={password} onChange={(e) => setPassword(e.target.value)} testId="login-password-input" />
        </div>
        <FormError error={error} />
        <Button type="submit" disabled={busy} className="w-full h-11 mystic-btn text-[#0B0C10] font-semibold tracking-wide" data-testid="login-submit-button">
          {busy && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}Sign in
        </Button>
        <p className="text-sm text-slate-400 text-center">New here? <Link to="/signup" className="text-[#FFB800] hover:underline" data-testid="goto-signup-link">Create an account</Link></p>
      </form>
    </AuthLayout>
  );
}
